import { render, staticRenderFns } from "./Klant.vue?vue&type=template&id=67b5e045&scoped=true&"
import script from "./Klant.vue?vue&type=script&lang=js&"
export * from "./Klant.vue?vue&type=script&lang=js&"
import style0 from "./Klant.vue?vue&type=style&index=0&id=67b5e045&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b5e045",
  null
  
)

export default component.exports